import { render, staticRenderFns } from "./download-video-modal.vue?vue&type=template&id=57c21abf&scoped=true&"
import script from "./download-video-modal.vue?vue&type=script&lang=js&"
export * from "./download-video-modal.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=57c21abf&scoped=true&lang=scss&"
import style1 from "./download-video-modal.vue?vue&type=style&index=1&id=57c21abf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c21abf",
  null
  
)

component.options.__file = "download-video-modal.vue"
export default component.exports